import { Kaggle } from "@kaggle/sdk";
import { getServices } from "../../../api/getServices";
import { Role } from "../../types/Role";
import { getStore } from "../store/appStore";
import { AppAction } from "../types";
import { UserState } from "../types/UserState";

export enum ActionKey {
  SET_USER = "SET_USER",
}

interface SetUserAction
  extends AppAction<ActionKey.SET_USER, { user: UserState }> {}

export type ViewerAction = SetUserAction;

const setUser = (
  id: number,
  username: string,
  name: string,
  thumbnail: string,
  isPhoneVerified: boolean,
  role: Role,
  userPlan: Kaggle.Sdk.Users.UserPlan
): SetUserAction =>
  getStore().dispatch({
    type: ActionKey.SET_USER,
    payload: {
      user: { id, username, name, thumbnail, isPhoneVerified, role, userPlan },
    },
  });

/**
 * Updates app state with the ID of the current viewing user.
 *
 * @param services Services API
 */
export const fetchViewer = async () => {
  const services = getServices();
  const user = await services.usersClient.usersService.getCurrentUser({
    includeGroups: false,
  });
  const userPlan = user.id
    ? (await services.usersClient.planService.getUserPlan({ userId: user.id }))
        .currentPlan
    : Kaggle.Sdk.Users.UserPlan.FREE;

  const role =
    user === null || user.isAnonymous
      ? "anonymous"
      : user.isAdmin
      ? "admin"
      : "user";
  setUser(
    (user && user.id) || 0,
    (user && user.userName) || "",
    (user && user.displayName) || "",
    (user && user.thumbnailUrl) || "",
    (user && user.isPhoneVerified) || false,
    role,
    userPlan
  );
};
